import React, { useContext, useEffect } from "react";
import { CartContext } from "../context/CartContext";

const futura = "'Futura', sans-serif";

const CartAddedPopup = ({ open, onClose, productId, productName }) => {
  const { cart, updateQuantity } = useContext(CartContext);
  const item = cart.find((i) => i.id === productId);
  const qty = item ? item.quantity : 0;

  useEffect(() => {
    if (!open) return;
    const onEsc = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, [open, onClose]);

  if (!open) return null;

  const dec = () => {
    if (qty > 1) updateQuantity(productId, qty - 1);
  };
  const inc = () => {
    if (item) updateQuantity(productId, qty + 1);
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        animation: "fadeIn 0.2s ease",
        fontFamily: futura,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "white",
          borderRadius: "16px",
          padding: "28px 28px 22px",
          width: "100%",
          maxWidth: "420px",
          boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            background: "#eaf7ea",
            color: "#2e7d32",
            fontSize: "26px",
            fontWeight: 700,
            marginBottom: "12px",
          }}
        >
          ✓
        </div>
        <h3
          style={{
            fontFamily: futura,
            fontSize: "22px",
            margin: "0 0 4px",
            color: "#111",
          }}
        >
          Added to cart
        </h3>
        <p
          style={{
            fontFamily: futura,
            margin: "0 0 20px",
            color: "#666",
            fontSize: "15px",
          }}
        >
          {productName}
        </p>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            marginBottom: "22px",
          }}
        >
          <span style={{ color: "#666", fontSize: "14px" }}>Quantity:</span>
          <button
            type="button"
            onClick={dec}
            disabled={qty <= 1}
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              background: "white",
              cursor: qty <= 1 ? "not-allowed" : "pointer",
              fontSize: "18px",
              fontWeight: 700,
              opacity: qty <= 1 ? 0.4 : 1,
              fontFamily: futura,
            }}
          >
            −
          </button>
          <span
            style={{
              fontFamily: futura,
              fontSize: "20px",
              fontWeight: 700,
              minWidth: "32px",
              color: "#111",
            }}
          >
            {qty}
          </span>
          <button
            type="button"
            onClick={inc}
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              background: "white",
              cursor: "pointer",
              fontSize: "18px",
              fontWeight: 700,
              fontFamily: futura,
            }}
          >
            +
          </button>
        </div>

        <a
          href="/cart"
          style={{
            display: "block",
            background: "#ff7d1a",
            color: "white",
            padding: "14px 24px",
            borderRadius: "8px",
            fontWeight: 700,
            fontSize: "15px",
            cursor: "pointer",
            letterSpacing: "1px",
            fontFamily: futura,
            textTransform: "uppercase",
            textDecoration: "none",
            marginBottom: "10px",
            boxShadow: "0 4px 14px rgba(255,125,26,0.35)",
          }}
        >
          Go to cart →
        </a>
        <button
          type="button"
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            color: "#666",
            fontSize: "14px",
            cursor: "pointer",
            fontFamily: futura,
            padding: "8px",
          }}
        >
          Keep browsing
        </button>
      </div>
    </div>
  );
};

export default CartAddedPopup;
